import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

const vuexLocal = new VuexPersist({
  storage: window.localStorage,
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    uName: null,
    uType: null,
    uAuth: null,
    uID: null,
    uPass: null,
    uMode: true,
  },
  mutations: {
    uNameUpdate(state, uName) {
      state.uName = uName;
    },
    uModeUpdate(state, uMode) {
      state.uMode = uMode;
    },
    uTypeUpdate(state, uType) {
      state.uType = uType;
    },
    uAuthUpdate(state, uAuth) {
      state.uAuth = uAuth;
    },
    uIDUpdate(state, uID) {
      state.uID = uID;
    },
    uPassUpdate(state, uPass) {
      state.uPass = uPass;
    },
  },
  getters: {
    isFilled: (state) => {
      return state.uName && state.uType && state.uAuth;
    },
    isIDFilled: (state) => {
      return state.uID && state.uPass;
    },
    canGenCode: (state) => {
      return (
        state.uName && state.uType && state.uAuth && state.uID && state.uPass
      );
    },
  },
  actions: {},
  modules: {},
  plugins: [vuexLocal.plugin],
});
